import React from 'react';

import { Box, Flex, Link, Text } from '@rover/kibble/core';
import Elevator from '@rover/react-lib/src/components/utils/Elevator/Elevator';

import RoverIcon from '../../../sitter-profile/SitterProfilePage/components/GuaranteeBanner/rover-icon.svg';

export const GuaranteeBanner = (): JSX.Element => {
  const elevatorStyles = {
    style: { borderRadius: '8px' },
  };

  return (
    <Box paddingBottom="12x">
      <Elevator elevation={1} {...elevatorStyles} data-testid="rover-guarantee-banner">
        <Box width={['100%', '750px', '970px', '1170px']}>
          <Flex
            paddingBottom="0x"
            flexDirection="column"
            alignItems="flex-start"
            gap="2x"
            alignSelf="stretch"
            background="primary"
            sx={{ borderRadius: '8px' }}
          >
            <Flex padding="4x" alignItems="center" gap="4x" alignSelf="stretch">
              <RoverIcon height={64} width={64} description="Rover Logo" />

              <Flex flexDirection="column" alignItems="flex-start" flex="1 0 0">
                {/* TODO (DEV-104195): Translate below text after training pilot launch */}
                <Text size="200">
                  All stays booked on Rover receive{' '}
                  <Link size="200" href="https://www.rover.com/rover-guarantee/">
                    our Rover guarantee
                  </Link>
                  , 24/7 support, and our reservation protection.
                </Text>
              </Flex>
            </Flex>
          </Flex>
        </Box>
      </Elevator>
    </Box>
  );
};
